module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon30.d451d753.png";